import { gql } from "@apollo/client";

export const PRODUCTION_REPORTS = gql`
  query GetProductionReports {
    getProductionReports {
      id
      name
    }
  }
`;

export const PRODUCTS = gql`
  query GetProducts($productionReportId: Int!, $date: DateTime!) {
    getProducts(productionRepordId: $productionReportId, date: $date) {
      id
      name
      no
      amount
      total
    }
  }
`;

export const UPDATE_PRODUCT_AMOUNT = gql`
  mutation updateProductAmount(
    $amount: Float!
    $productId: Int!
    $date: DateTime!
  ) {
    updateProductAmount(amount: $amount, productId: $productId, date: $date)
  }
`;

export const UPDATE_PRODUCT_AMOUNT_BULK = gql`
  mutation updateProductAmountBulk($args: [UpdateProductAmountArgs!]!) {
    updateProductAmountBulk(args: $args)
  }
`;

export const ORDERS_COUNT = gql`
  query GetOrdersCount($date: DateTime!) {
    ordersCount(date: $date)
  }
`;

export const PRE_ORDERS_COUNT = gql`
  query GetPreOrdersCount($date: DateTime!) {
    preOrdersCount(date: $date)
  }
`;
